import { render, staticRenderFns } from "./ConversationsButton.vue?vue&type=template&id=05069526&scoped=true&"
import script from "./ConversationsButton.vue?vue&type=script&lang=js&"
export * from "./ConversationsButton.vue?vue&type=script&lang=js&"
import style0 from "./ConversationsButton.vue?vue&type=style&index=0&id=05069526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05069526",
  null
  
)

export default component.exports